import { render, staticRenderFns } from "./AiMyprPrQuestionsForm.vue?vue&type=template&id=23c451e8"
import script from "./AiMyprPrQuestionsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiMyprPrQuestionsForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports